<template>
  <v-container id="registerPage" >
    <v-progress-linear id="registrationLoad" v-if="!hasProfileLoaded" color="blue" class="mt-0" indeterminate />
    <v-layout v-else row wrap>
      <v-layout pa-3 mb-2 justify-center row wrap>
        <v-flex xs12 md6>
          <v-card>
            <v-card-title class="pb-0">
              <v-layout row wrap>
                <v-flex xs12 class="text-xs-center">
                  <h2 v-if="registrationType === 'life_renewal'" class="headline">Life Membership Renewal Application</h2>
                  <h2 v-else-if="registrationType === 'sponsor_renewal'" class="headline">Sponsor Membership Application</h2>
                  <h2 v-else-if="registrationType === 'member_renewal'" class="headline">Membership Renewal Application</h2>
                  <h2 v-else class="headline">New Membership Application</h2>
                </v-flex>
              </v-layout>
            </v-card-title>
            <v-card-text class="pt-0 pb-0">
              <v-layout row wrap justify-start>
                <v-flex xs12 justify-start mb-2>
                  <h3 class="headline">Account Holder Information</h3>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm6 md4 pr-2>
                  <v-text-field
                    label="Given Name"
                    placeholder="Submit your First Name"
                    v-model="firstName"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md8>
                  <v-text-field
                    label="Family Name"
                    placeholder="Submit your First Name"
                    v-model="lastName"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm6 md8 pr-2>
                  <v-text-field
                    label="Address"
                    placeholder="Enter Your Street Address"
                    v-model="address.street"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    label="Postcode"
                    maxLength="4"
                    placeholder="Enter Your Postcode"
                    mask="####"
                    v-model="address.postcode"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm6 md8 pr-2>
                  <v-text-field
                    label="Suburb"
                    placeholder="Enter Your Suburb"
                    v-model="address.suburb"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-select
                    label="State"
                    :items="stateItems"
                    v-model="address.state"
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-text class="pt-0 pb-0">
              <v-layout row wrap>
                <v-flex xs12 justify-start mb-0>
                  <h3 class="headline">Secondary Contact</h3>
                </v-flex>
                <v-flex xs12 justify-start mb-0>
                  <small><strong>OPTIONAL</strong> - case we need to contact a family member for you while you're at the track</small>
                </v-flex>
                <v-flex xs12 sm6 pr-2>
                  <v-text-field
                    label="Contact Number"
                    placeholder="Enter a Phone Number"
                    v-model="secondPhone"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                    label="Contact Name"
                    placeholder="Add the contact's name here"
                    v-model="secondName"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 justify-start mb-0>
                  <h3 class="headline">Rider Information</h3>
                </v-flex>
                <v-flex xs12 justify-start mb-0>
                  <small>Maximum of 7 Riders per membership (Account Holder + 6 Riders)</small><br/>
                  <small><strong>Account Holders are automatically counted as riders</strong></small>
                </v-flex>
                <v-flex xs12>
                  <v-list>
                    <v-list-tile class="grey lighten-2">
                      <v-flex xs4 pl-4>
                        <strong>Account Holder</strong>
                      </v-flex>
                      <v-flex xs4>
                        <span>{{ user.attributes.given_name + ' ' + user.attributes.family_name }}</span>
                      </v-flex>
                      <v-flex xs4 pr-4 class="text-xs-right">
                        <span>{{members.length}}/{{familyMax}}</span>
                      </v-flex>
                    </v-list-tile>
                    <v-list-tile v-for="(member, ix) in members" :key="member.id" class="familyList">
                      <v-flex xs4 pl-4>
                        <span>{{ member.firstName }}</span>
                      </v-flex>
                      <v-flex xs4>
                        <span>{{ member.lastName }}</span>
                      </v-flex>
                      <v-spacer/>
                      <v-flex xs1 class="text-xs-right">
                        <v-btn flat fab small grey color="grey" @click="removeMember(member.id)">
                          <v-icon>close</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-list-tile>
                    <v-list-tile>
                      <v-flex xs5 mt-4 pr-2>
                        <v-text-field
                          label="First Name"
                          v-model="newMember.firstName"
                        />
                      </v-flex>
                      <v-flex xs5 mt-4 pr-2>
                        <v-text-field
                          label="Last Name"
                          v-model="newMember.lastName"
                        />
                      </v-flex>
                      <v-spacer/>
                      <v-flex xs2 mt-4>
                        <v-btn flat small block outline color="orange" @click="addNewFamily()">Add</v-btn>
                      </v-flex>
                    </v-list-tile>
                  </v-list>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout pa-3 mb-2 justify-center row wrap>
        <v-flex xs12 md6>
          <v-card>
            <v-card-title class="pb-0">
              <v-layout row wrap justify-start>
                <v-flex xs12 justify-start mb-2>
                  <h3 class="headline">Committee Volunteer</h3>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 pb-2>
                  MCTC is calling on all new applicants to take a larger part in our community by volunteering to become apart of our club committee.
                  Volunteers chosen will take a wider role within the club, with additional responsibilities and benefits.
                  Ticking the box below will notify the club of your interest, chosen candidates will be notified at a later date.
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 pb-2>
                <strong>Committee Responsibilities:</strong><br/>
                <ul>
                  <li>Take on an active role in the Club</li>
                  <li>Will be required to do <strong>one extra track duty day</strong> over general members</li>
                  <li>May be asked to act as day supervisor during rostered duty days</li>
                </ul>
              </v-flex>
              <v-flex xs12 pb-2>
                <strong>Benefits:</strong><br/>
                <ul>
                  <li>Completing 12 months as a club committee member and attending all your duties will make you eligible for an extra rebate on your membership fees</li>
                </ul>
              </v-flex>
            </v-layout>
            <v-layout row wrap pl-3>
              <v-flex xs12>
                <v-checkbox
                  v-model="committeeOptIn"
                  label="I would like to do more by joining the club committee and enter my name in as a potential candidate"
                />
              </v-flex>
            </v-layout>
            <v-layout row wrap justify-start>
              <v-flex xs12 justify-start mb-2>
                <h3 class="headline">Track Duties</h3>
              </v-flex>
              <v-flex xs12 pb-2>
                All registered members are required to attend at least 2 separate days of track duties during their 12 month membership. This Duty comes in the form of supervision of activites within the club premises during regular operating hours.<br/><br/>
                Review the below calendar and select two available dates of coming weekends. 3 volunteers are needed each day during open hours, with one acting as day supervisor.
                <br/><br/>
                <p><strong>Note:</strong> Members who elect to join the club committee must complete at least <strong>3</strong> days of track duty, instead of the regular 2</p>
              </v-flex>
            </v-layout>
            </v-card-title>
            <v-card-text pt-0>
              <v-layout wrap row pb-3>
                <v-flex xs12 md6 pb-3>
                  <v-layout wrap row pb-3>
                    <v-flex xs12 md4 pa-1>
                      <v-select label="Year" v-model="selectedYear" :items="getYearList()" @change="changeSelectedYear()"/>
                    </v-flex>
                    <v-flex xs12 md8 pa-1>
                      <v-select label="Month" v-model="selectedMonth" :items="getMonthList()" @change="changeSelectedMonth()"/>
                    </v-flex>
                  </v-layout>
                  <v-layout wrap row pb-3>
                    <MonthView
                      ref="monthcomp"
                      :key="rosterCompKey"
                      :currentYear="selectedYear"
                      :currentMonth="selectedMonthIndex"
                      v-on:setDate="setVolunteerDates($event)"
                    />
                  </v-layout>
                </v-flex>
                <v-flex xs12 md6 pb-3 mt-4 >
                  <v-layout row wrap>
                    <v-flex xs12 mb-2 pa-0 class="orangeBorder">
                      <h3 class="subheading pb-1 pl-2" :class="enoughDays"><strong>My Selections {{volunteerDays.length || 0}}/{{ committeeOptIn ? 3 : 2}}</strong></h3>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12 mb-0 pl-2 v-for="(day, ix) in volunteerDays" :key="ix">
                      <v-layout row wrap>
                        <v-flex xs2>
                          <strong>#{{ix+1}}:</strong>
                        </v-flex>
                        <v-flex xs10 mb-2>
                          <v-layout row wrap>
                            <v-flex xs10 mb-2 text-xs-left>
                              {{formatDate(day)}}
                            </v-flex>
                            <v-flex xs2 mb-2 text-xs-right>
                              <v-btn color="red lighten-1" id="datebtn" class="white--text" depressed fab small title="Add this Date" @click="removeDate(ix)">
                                <v-icon>close</v-icon>
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout pa-3 mb-2 justify-center row wrap>
        <v-flex xs12 md6>
          <v-card :disabled="true">
            <v-card-title class="pb-0">
              <h2 class="headline mb-0">Summary</h2>
            </v-card-title>
            <v-card-text pt-0>
              <v-layout row wrap mb-4 pa-3 class="summaryTotal">
                <v-flex xs8>
                  {{ `${membershipTypeName}${committeeOptIn ? ' + Committee Opt-In' : '' }`}}
                </v-flex>
                <v-flex xs4 class="text-xs-right">
                  {{purchasePrice}}
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12>
                  All new membership applicants must first read through the <a href="javascript:;" @click.stop="terms = true">MCTC Membership Aggreement</a>
                </v-flex>
                <v-flex xs12>
                  <v-checkbox color="green"
                    v-model="hasAcceptedTerms"
                    label="I Accept the MCTC Membership Agreement Terms"
                  />
                </v-flex>
              </v-layout>
              <v-divider/>
              <v-layout row wrap justify-center>
                <v-flex v-if="(membershipType !== 'life' && membershipType !== 'sponsor')" xs12 md6>
                  <v-flex v-show="isRegistrationFilled">
                    <v-flex v-show="!loading">
                    <PayPal
                      :amount="membershipTypePrice"
                      v-on:paypal-success="paypalEmitSuccess($event)"
                      v-on:paypal-error="paypalEmitError($event)"
                    />
                    </v-flex>
                    <v-flex v-show="loading">
                      <v-btn loading block color="success" depressed></v-btn>
                    </v-flex>
                  </v-flex>
                </v-flex>
                <v-flex v-else xs12 md6>
                  <v-btn :disabled="!isRegistrationFilled" :loading="loading" block color="success" depressed @click="validateRegistration()">COMPLETE REGISTRATION</v-btn>
                </v-flex>
                <v-flex xs12>
                  <v-alert v-show="isAlertActive" value=true :type="alert.class">
                    {{alert.message}}
                  </v-alert>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-layout>
    <v-dialog v-model="terms" width="70%" lazy :fullscreen="isMobile">
      <v-card>
        <v-card-title class="pb-0">
          <v-layout row wrap pa-2>
            <v-flex xs12 class="text-xs-center">
              <h2 class="headline">MCTC Membership Agreement</h2>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-card-text>
          <terms/>
        </v-card-text>
        <v-card-actions>
          <v-layout row wrap justify-center>
            <v-flex xs4 pb-4>
              <v-btn
                depressed
                block
                color="success"
                class="white--text"
                @click="terms = false"
              >Ok</v-btn>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import store from '@/store'
import terms from '@/components/terms'
import volunteerSchedule from '@/data/volunteerSchedule'
import MonthView from '@/components/MonthView'
import PayPal from '@/components/PayPal'
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {
    terms,
    PayPal,
    MonthView
  },
  computed: {
    ...mapGetters({
      user: 'getUser',
      isActive: 'isActiveSubscription',
      hasRegistered: 'hasUserRegistered',
      subscription: 'getSubscription',
      secondary: 'getSecondary',
      myAddress: 'getAddress',
      isSponsor: 'isSponsor',
      isCommittee: 'isCommittee',
      isExecutive: 'isExecutive',
      family: 'getAccountMembers',
      roster: 'getRoster',
      profile: 'getProfile'
    }),
    hasRoster () {
      return (this.roster !== undefined && this.roster !== null)
    },
    hasProfileLoaded () {
      return (this.profile)
    },
    setyeartab () {
      const years = this.getYearList()
      console.log(years)
      return years.indexOf(this.currentYear)
    },
    setSelectedYear () {
      return this.currentYear
    },
    selectedMonthIndex () {
      return `${this.months.indexOf(this.selectedMonth)}`
    },
    setSelectedMonth () {
      return this.months[this.currentMonth]
    },
    setmonthtab () {
      let months = this.getMonthList()
      let monthname = this.months[this.currentMonth]
      return months.indexOf(monthname)
    },
    user () {
      return store.state.user.user
    },
    isAlertActive () {
      return (this.alert.active)
    },
    enoughDays () {
      const dayCount = this.committeeOptIn ? 3 : 2
      if (!this.volunteerDays || this.volunteerDays.length < dayCount) return 'error--text'
      return ''
    },
    isRegistrationFilled () {
      // Address Fields
      if (!this.address.street) return false
      if (!this.address.state) return false
      if (!this.address.postcode) return false
      if (!this.address.suburb) return false
      // Family Members
      if (this.members.length <= 0) return false
      // Volunteer Days
      const dayCount = this.committeeOptIn ? 3 : 2
      if (!this.volunteerDays || this.volunteerDays.length < dayCount) return false
      // Terms
      if (!this.hasAcceptedTerms) return false
      if (this.isSuccess) return false
      return true
    },
    myPayPalItem () {
      if (this.committeeOptIn) return [ this.membershipTypes.standard ]
      else return [ this.membershipTypes.optin ]
    },
    isPayPalDone () {
      return (this.paypal.response && this.isRegistrationFilled)
    },
    registrationType () {
      if (!this.hasRegistered) return 'member_new'

      if (this.subscription.type === 'life') return 'life_renewal'
      if (this.isSponsor) return 'sponsor_renewal'

      return 'member_renewal'
    },
    isRosterLoaded () {
      return (this.roster !== undefined && this.roster)
    },
    purchasePrice () {
      if (this.membershipTypePrice <= 0) return 'FREE'
      return `$${this.membershipTypePrice}.00 AUD`
    },
    membershipTypePrice () {
      return this.membershipTypes[this.membershipType].price
    },
    membershipTypeName () {
      return this.membershipTypes[this.membershipType].name
    },
    membershipType () {
      let type = 'new'

      if (this.registrationType === 'member_renewal') type = 'standard'
      if (this.registrationType === 'life_renewal') type = 'life'
      if (this.registrationType === 'sponsor_renewal') type = 'sponsor'
      return type
    },
    isMobile () {
      return (window.innerWidth < 960)
    }
  },
  methods: {
    ...mapActions([
      'submitRegistration',
      'loadRoster',
      'getMemberProfile'
    ]),
    removeDate (index) {
      let date = this.volunteerDays[index]
      let comp = this.$refs.monthcomp
      comp.setDate(date)
    },
    setVolunteerDates: function (dates) {
      console.log('New volunteer dates')
      console.log(dates)
      this.volunteerDays = dates
    },
    getMonth: function (month) {
      return this.months[month - 1]
    },
    getYearList: function () {
      const time = new Date()
      const years = [`${time.getFullYear()}`]

      time.setFullYear(time.getFullYear() + 1)
      years.push(`${time.getFullYear()}`)

      return years
    },
    getMonthList: function () {
      const list = []
      const time = new Date()
      let month = time.getMonth()
      if (this.selectedYear === this.currentYear) {
        let month = time.getMonth()
        let ix = month
        while (ix < 12) {
          list.push(this.months[time.getMonth()])
          time.setMonth(time.getMonth() + 1)
          ix++
        }

        return list
      }

      let ix = 0
      time.setFullYear(this.selectedYear)
      time.setMonth(0)
      while (ix <= month) {
        list.push(this.months[time.getMonth()])
        time.setMonth(time.getMonth() + 1)
        ix++
      }

      return list
    },
    changeSelectedYear: function () {
      if (this.selectedYear === this.currentYear) this.selectedMonth = this.months[this.currentMonth]
      else this.selectedMonth = 'January'

      this.changeSelectedMonth()
    },
    changeSelectedMonth: function () {
      let month = this.$refs.monthcomp
      month.generateList(this.selectedYear, this.selectedMonthIndex)
    },
    getMonthIndex: function (monthname) {
      return this.months.indexOf(monthname)
    },
    paypalEmitSuccess: function (data) {
      console.log('PAYPAL SUCCESS')
      console.log(data)
      this.paypal.response = data

      this.alert.status = true
      this.alert.class = 'success'
      this.alert.message = 'Payment has been Successfully Received! Completing Registration...'

      this.validateRegistration()
    },
    paypalEmitError: function (data) {
      console.log('PAYPAL ERROR')
      console.log(data)
      this.alert.status = true
      this.alert.class = 'error'
      this.alert.message = 'Error #000001 - There was an issue processing your payment, please wait a few moments and try again.'
    },
    addNewFamily: async function () {
      if (this.members.length >= 6) return false
      console.log('Adding New Member to Family')
      console.log('Previous ID:', this.tempId)
      const firstName = this.newMember.firstName.trim()
      const lastName = this.newMember.lastName.trim()
      if (firstName && lastName) {
        const id = `${firstName}${lastName}`

        this.members.push({ id, firstName, lastName })
        this.newMember.firstName = null
        this.newMember.lastName = null
        return true
      }

      return false
    },
    removeMember: function (id) {
      let newMembers = []
      this.members.forEach((item, index) => {
        if (item.id !== id) newMembers.push(item)
      })

      this.members = []
      this.members = newMembers
    },
    validateRegistration: async function () {
      this.loading = true
      this.alert.active = false
      this.alert.message = ''
      console.log('Validated Registration Form Submitted')
      const registration = {
        type: this.registrationType,
        personal: {
          given_name: this.firstName,
          family_name: this.lastName
        },
        secondary: {
          number: this.secondPhone,
          name: this.secondName
        },
        address: this.address,
        members: this.members,
        dutyDays: this.volunteerDays,
        committeeOptIn: this.committeeOptIn,
        paypal: this.paypal.response,
        agreement: this.hasAcceptedTerms
      }

      console.log(registration)
      let result = await this.submitRegistration(registration)
      console.log(result)
      if (result.user && !result.hasError) {
        this.isSuccess = true
        console.log('REGISTRATION GOOD')
        console.log(result.user)
        this.loading = false
        this.alert.active = true
        this.alert.class = 'success'
        this.alert.message = 'Registration Completed!'
        setTimeout(() => (this.$router.push('/account')), 1000)
        return true
      }

      this.loading = false
      this.alert.active = true
      this.alert.class = 'error'
      this.alert.message = 'There was an error finalising your registration. Please wait a few moments and try again.'
      console.log('HAS ERROR')
      return false
    },
    formatDate: function (timestring, format = 'words') {
      if (timestring === undefined || !timestring) return ''
      let days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
      let time = new Date(timestring)

      return `${days[time.getDay()]}, ${time.getDate()} ${this.months[time.getMonth()]} ${time.getFullYear()}`
    }
  },
  data () {
    return {
      rosterCompKey: 0,
      yeartab: null,
      monthtab: null,
      months: ['January', 'February', 'March', 'Apil', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      currentYear: `${new Date().getFullYear()}`,
      currentMonth: new Date().getMonth(),
      selectedYear: null,
      selectedMonth: null,
      loading: false,
      familyMax: 6,
      secondPhone: null,
      secondName: null,
      isSuccess: false,
      membershipTypes: {
        new: {
          name: 'MCTC Standard 12 Month Membership + $50 Sign-Up Fee',
          description: 'Yearly Membership + $50 Sign-Up Fee',
          quantity: '1',
          price: 300
        },
        standard: {
          name: 'MCTC 12 Month Membership Renewal',
          description: 'Annual Membership Renewal for Existing Members',
          quantity: '1',
          price: 250
        },
        committee: {
          name: 'MCTC 12 Committee Membership Renewal',
          description: 'Annual Committee Membership Renewal',
          quantity: '1',
          price: 250
        },
        life: {
          name: 'MCTC Life Membership Renewal',
          description: 'Annual Renewal for Life Members',
          quantity: '1',
          price: 0
        },
        sponsor: {
          name: 'MCTC Sponsor Membership Renewal',
          description: 'Annual Renewal for Club Sponsors',
          quantity: '1',
          price: 0
        }
      },
      paypal: {
        response: null
      },
      alert: {
        active: false,
        class: 'error',
        message: ''
      },
      tempId: 0,
      newMember: {
        firstName: null,
        lastName: null
      },
      firstName: null,
      lastName: null,
      address: {
        street: null,
        postcode: null,
        suburb: null,
        state: null
      },
      members: [],
      volunteerDays: [],
      hasAcceptedTerms: false,
      datePicker: false,
      committeeOptIn: false,
      terms: false,
      stateItems: ['NT', 'NSW', 'QLD', 'SA', 'TAS', 'VIC', 'WA']
    }
  },
  created () {
    this.firstName = this.user.attributes.given_name
    this.lastName = this.user.attributes.family_name
    this.address = this.myAddress
    this.secondPhone = this.secondary.number || null
    this.secondName = this.secondary.name || null
    this.members = (this.family && this.family.length > 0) ? this.family : []
    if (this.isCommittee) this.committeeOptIn = this.isCommittee
  },
  mounted () {
    this.getMemberProfile()
    this.yeartab = this.setyeartab
    this.monthtab = this.setmonthtab
    this.selectedYear = this.setSelectedYear
    this.selectedMonth = this.setSelectedMonth
  }
}
</script>
<style>
  #registerPage {
    margin-bottom: 100px;
  }
  #registrationLoad {
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
  }
  #datebtn {
    height: 20px;
    width: 20px;
    margin: 0;
  }
  #specialOffer {
    font-size: 2rem;
    background-color: darkgreen;
    padding: 5px 20px;
    border-radius: 3px;
    width: fit-content;
    color: white;
  }
  .summaryTotal {
    border-top: solid 2px darkgray;
    border-bottom: solid 2px darkgray;
  }
  .familyList {
    border-bottom: solid 1px lightgrey;
  }
  .orangeBorder {
    border-bottom: solid 1px orange;
  }
</style>
